// 3D-Werkstatt: printable designs. Each template builds solids from its parameters (see
// tako.js) and brings what else the print needs: hardware, slicer settings, build steps.

import { TAKO_PARAMS, takoDefaults, buildTako } from './tako.js'
import { MINI_PARAMS, miniDefaults, buildTakoMini } from './takoMini.js'

export const PRINTERS = {
  'snapmaker-u1': { name: 'Snapmaker U1', bed: [270, 270, 270], note: '4 Werkzeugköpfe (SnapSwap), Orca Slicer' },
}

export const PRINT_TEMPLATES = [
  {
    id: 'tako',
    name: 'Tako-Gehäuse',
    icon: 'developer_board',
    desc: 'Tischgehäuse für den Tako-Hub: E-Paper schräg in der Front, ESP32, Relais und Vibrationstreiber auf der Bodenplatte. Verschraubt mit M3-Gewindeeinsätzen.',
    params: TAKO_PARAMS,
    defaults: takoDefaults,
    build: buildTako,
    hardware: [
      { name: 'Gewindeeinsatz M3 (Ø 4,0 × 5,7 mm, z. B. Ruthex)', count: 6, note: '4 in die Eckdome, 2 neben dem E-Paper' },
      { name: 'Senkkopfschraube M3 × 8 (ISO 10642)', count: 4, note: 'Bodenplatte von unten' },
      { name: 'Zylinderkopfschraube M3 × 8', count: 2, note: 'E-Paper-Halter' },
      { name: 'Gummifüße selbstklebend Ø 10 mm', count: 4, note: 'in die Vertiefungen unter der Bodenplatte' },
      { name: 'Kabelbinder 2,5 mm', count: 1, note: 'hält das ESP32 auf seiner Brücke' },
      { name: 'Doppelseitiges Schaumklebeband', count: 1, note: 'Relais und Vibrationstreiber in ihren Wannen' },
    ],
    settings: [
      ['Material', 'PETG (oder PLA — innen wird es kaum warm)'],
      ['Schichthöhe', '0,2 mm'],
      ['Wände', '3 Perimeter, oben/unten je 4 Schichten'],
      ['Füllung', '15 % Gyroid'],
      ['Stützen', 'keine — das Gehäuse liegt kopfüber, die Front neigt sich nur 18°'],
      ['Haftung', 'kein Brim nötig; bei PETG Bett 70–80 °C'],
      ['Orca', 'STL importieren, Teile nicht drehen — sie liegen schon richtig. Bei mehreren Köpfen: Front z. B. in einer zweiten Farbe ist mit „Farbe malen“ möglich.'],
    ],
    measure: [
      'E-Paper-Platine Breite × Höhe und Glas + Platine zusammen (Messschieber).',
      'Wo sitzt das Sichtfeld auf der Platine? Liegt seine Mitte nicht in der Platinenmitte: „Fenster seitlich versetzt“ / „höher/tiefer“ eintragen.',
      'ESP32-Board Länge × Breite (Klone weichen ab: 51–55 × 26–29 mm).',
      'Relais-Modul und Vibrationstreiber: Länge × Breite.',
    ],
    steps: [
      { t: 'Messen', d: 'Vor dem Druck die Module nachmessen und die Maße links eintragen — das Modell passt sich an. Ein roter Hinweis zeigt, wenn etwas nicht mehr passt.' },
      { t: 'Drucken', d: 'Alle drei STL laden (Gehäuse, Bodenplatte, E-Paper-Halter) und mit den Einstellungen rechts drucken — Orca zeigt danach Druckzeit und Filament.' },
      { t: 'Gewindeeinsätze', d: 'Mit dem Lötkolben (PETG ca. 230 °C, PLA ca. 200 °C) gerade einsetzen: vier in die Eckdome von unten, zwei in die Dome neben dem E-Paper-Fenster. Bündig einschmelzen, abkühlen lassen.' },
      { t: 'E-Paper', d: 'Modul mit dem Glas zum Fenster in die vier Eckführungen legen (Kabelstecker frei lassen), Halter darüber und mit 2 × M3 × 8 handfest verschrauben. Nicht zu fest — das Glas bricht leicht.' },
      { t: 'ESP32', d: 'Jumperkabel an die Stiftleisten, dann das Board mit dem Antennenende unter die Lippe der vorderen Brücke schieben und auf die hintere Brücke legen (USB nach hinten). Mit einem Kabelbinder durch den Schlitz sichern.' },
      { t: 'Relais und Motor', d: 'Mit Schaumklebeband in ihre Wannen kleben, Anschlüsse zur Lücke in der Wannenwand. Verdrahten nach Schaltplan (Dashboard → Docs → Schaltpläne → Tako). Kabel des Relais hinten durch den kleinen Schlitz.' },
      { t: 'Schließen', d: 'USB-Kabel einstecken, Gehäuse senkrecht über die Bodenplatte senken — das Kabel läuft durch die Aussparung hinten. Mit 4 × M3 × 8 Senkkopf von unten verschrauben, Gummifüße aufkleben.' },
    ],
  },
]

PRINT_TEMPLATES.unshift({
  id: 'tako-mini',
  name: 'Tako mini',
  icon: 'memory',
  desc: 'So klein wie möglich: das E-Paper füllt die schräge Front, dahinter ESP32 (Drähte angelötet), Relais hochkant und Vibrationstreiber. Zwei Druckteile, zwei M3-Schrauben.',
  params: MINI_PARAMS,
  defaults: miniDefaults,
  build: buildTakoMini,
  hardware: [
    { name: 'Gewindeeinsatz M3 (Ø 4,0 × 5,7 mm, z. B. Ruthex)', count: 2, note: 'in die zwei Dome vorn unten' },
    { name: 'Senkkopfschraube M3 × 8 (ISO 10642)', count: 2, note: 'Bodenplatte von unten, vorn' },
    { name: 'Kabelbinder 2,5 mm', count: 1, note: 'hält das ESP32 auf seinen Stützen' },
    { name: 'Doppelseitiges Schaumklebeband', count: 1, note: 'Relais an die rechte Wand, Vibrationstreiber unter die Decke' },
    { name: 'Gummifüße selbstklebend Ø 8 mm', count: 4, note: 'unter die Bodenplatte' },
    { name: 'Litze 0,14–0,25 mm², mehrfarbig', count: 1, note: 'statt Dupont-Kabeln: an die Stiftleisten angelötet' },
  ],
  settings: [
    ['Material', 'PETG oder PLA'],
    ['Schichthöhe', '0,16–0,2 mm (feinere Schichten: sauberere Front)'],
    ['Wände', '4 Perimeter (die Wand ist 1,6 mm = 4 Linien à 0,4 mm), oben/unten je 5 Schichten'],
    ['Füllung', '20 % Gyroid'],
    ['Stützen', 'keine — Gehäuse kopfüber, Bodenplatte flach'],
    ['Orca', 'Teile nicht drehen, sie liegen schon richtig. Mit dem U1 z. B. die Front in einer zweiten Farbe malen.'],
  ],
  measure: [
    'E-Paper-Platine Breite × Höhe und Glas + Platine zusammen — die Front wird genau so groß.',
    'Wo sitzt das Sichtfeld auf der Platine? Mitte nicht in der Platinenmitte: „Fenster seitlich versetzt“ / „höher/tiefer“.',
    'Wie viel Platz brauchen Stifte und angelötete Kabel hinter dem Display? („Platz dahinter“)',
    'ESP32 Länge × Breite; Relais-Modul Länge, Breite und Dicke samt Relais; Vibrationstreiber.',
  ],
  steps: [
    { t: 'Messen', d: 'Module nachmessen und links eintragen — die Box wächst oder schrumpft mit. Ein gelber Hinweis zeigt, wenn etwas nicht mehr passt.' },
    { t: 'Verdrahten (gelötet)', d: 'Statt Dupont-Kabeln dünne Litze direkt anlöten: am ESP32 auf die Stiftenden oben auf der Platine, am Display an seine Stifte. Längen so kurz, wie es die Lage im Gehäuse erlaubt (Explosionsansicht).' },
    { t: 'Drucken', d: 'Gehäuse und Bodenplatte laden und drucken — Orca zeigt Zeit und Filament.' },
    { t: 'Gewindeeinsätze', d: 'Zwei M3-Einsätze mit dem Lötkolben (PETG ca. 230 °C, PLA ca. 200 °C) in die Dome vorn unten im Gehäuse.' },
    { t: 'Display einschieben', d: 'Das E-Paper mit dem Glas nach vorn von unten in die Front schieben, bis es oben anstößt — die vier kleinen Laschen an den Seiten halten es an der Front. Kabel nach hinten.' },
    { t: 'Innenleben', d: 'Vibrationstreiber unter die Decke kleben (über dem ESP32), Relais hochkant an die rechte Wand, Klemmen nach hinten. ESP32 auf die Stützen der Bodenplatte, vorn an die Stufe, mit dem Kabelbinder sichern.' },
    { t: 'Schließen', d: 'Bodenplatte hinten schräg einsetzen, bis die zwei Haken in die Schlitze der Rückwand greifen, vorn hochklappen — die Platte hält das Display unten. Zwei Schrauben M3 × 8 von unten, Füße aufkleben. USB-Kabel durch die Öffnung hinten.' },
  ],
})

export const PRINT_TEMPLATE = Object.fromEntries(PRINT_TEMPLATES.map((t) => [t.id, t]))

export function printProjectFromTemplate(id, name) {
  const t = PRINT_TEMPLATE[id]
  return { version: 1, kind: 'print', template: id, name: name || t.name, params: t.defaults(), printer: 'snapmaker-u1' }
}
